<template>
  <table
    style="border: 1px solid #bbb; border-bottom: 4px solid black"
    class="table align-items-center mb-0"
  >
    <thead>
      <tr style="color: black">
        <th scope="col">Patient Name: {{ name }}</th>
        <th scope="col">Age: {{ computedAge }}</th>
        <th scope="col">
          Gender:
          <span v-if="parseInt(gender) == 1">Male</span>
          <span v-if="parseInt(gender) == 2">Female</span>
          <span v-if="parseInt(gender) == 3">Other</span>
        </th>
        <th>Visit_id: {{ visit_data?.id  || visitId }}</th>
        <th>
          Visit Date:{{ formatDateTime(visit_data?.created_at) || formatDateTime(visit_date) }}
        </th>
        <th scope="col"><slot name="action-bt">.</slot></th>
      </tr>
    </thead>
  </table>
</template>

<script>
import formatDateTime from "../../../timezone/utc_local_time";
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "PatientBiodata",
  props: {
    patient_id: {
      type: String,
      required: false,
    },
    visit_data: {
      type: Object,
      required: false,
    },
    visit_id: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      name: "",
      gender: "",
      dob: "", // e.g., "1992-10-03"
      visitId:"",
      visit_date:"",
    };
  },
  computed: {
    computedAge() {
      if (!this.dob) return "";

      const dob = new Date(this.dob);
      const today = new Date();

      let years = today.getFullYear() - dob.getFullYear();
      let months = today.getMonth() - dob.getMonth();

      if (today.getDate() < dob.getDate()) {
        months -= 1;
      }

      if (months < 0) {
        years -= 1;
        months += 12;
      }

      return `${years} yrs ${months} months`;
    },
  },
  methods: {
    formatDateTime,
    async mountBiodata() {
      try {
        const url = "getUserById";
        const body = { user_id: this.patient_id };
        const res = await generalApiRequest(url, "POST", body, 1);
        console.log("====================");
        console.log(res);

        this.name = res.user.name;
        this.gender = res.user.gender;
        this.dob = res.user.dob;

        this.visitId = res.active_visit?.id;
        this.visit_date = res.active_visit?.created_at;
      } catch (error) {
        console.error("Error fetching patient data:", error);
      }
    },
  },
  mounted() {
    // console.log("===========================");

    // console.log(this.patient_id);
    // console.log("++++++++++++++++++++++++++++++++++");

    this.mountBiodata();
  },
};
</script>

<style scoped>
.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
}
</style>
